export const bonuses = [
  {
    number: 1,
    title: '50 Reflexology Study Cards™',
    value: 37,
    image: 'https://cdn.magicpatterns.com/uploads/ru4gNbU3GCj6aLkFHqj9ih/BONUS_1_REFLEXPRACTICE-EN.png',
    intro:
      'I created these visual study cards to help you review important reflexology concepts without sitting down for another long study session.',
    listLabel: 'Use them to',
    items: ['Review', 'Study', 'Quiz yourself', 'Reinforce concepts', 'Practice recall', 'Study from your phone', 'Print for offline use'],
    closing: 'One card. One concept. One small step forward.',
  },
  {
    number: 2,
    title: 'The 15-Minute Reflexology Practice Protocol™',
    value: 37,
    image: 'https://cdn.magicpatterns.com/uploads/wjC2VkDdbSHuVaMBdCFRnq/BONUS_2_REFLEXPRACTICE-EN.png',
    intro:
      "A compact framework I created for those days when you don't have much time but still want to practice.",
    listLabel: "You'll get",
    items: ['Preparation', 'Opening sequence', 'Practice sequence', 'Review', 'Closing', 'Timing guide', 'Practice checklist'],
    closing: "Because you don't need a free afternoon to practice reflexology. You can start with 15 minutes.",
  },
  {
    number: 3,
    title: "The Beginner's Reflexology Mistakes Guide™",
    value: 27,
    image: 'https://cdn.magicpatterns.com/uploads/2gSXPaeDfzJejExc3UBPoA/BONUS_3_REFLEXPRACTICE-EN.png',
    intro:
      'A practical guide to common organization and practice mistakes that can make learning reflexology feel more complicated than it needs to be.',
    listLabel: 'Identify potential problems involving',
    items: ['Study organization', 'Reference materials', 'Practice sequence', 'Consistency', 'Review', 'Documentation', 'Practice habits', 'Progress tracking'],
    closing: "Sometimes improving isn't about learning more. It's about removing the habits that make learning harder.",
  },
  {
    number: 4,
    title: 'The 21-Day Reflexology Practice Planner™',
    value: 29,
    image: 'https://cdn.magicpatterns.com/uploads/5MgnXxW2gCnNNZoQtYjTcA/BONUS_4_REFLEXPRACTICE-EN.png',
    intro: 'A dedicated planner designed to accompany you throughout the entire 21-day method.',
    listLabel: "You'll receive",
    items: ['Daily tracker', 'Practice checklist', 'Notes section', 'Weekly review', 'Progress tracker', 'Completion tracker', 'Final self-assessment'],
    closing: 'Every day follows four simple steps: LEARN → PRACTICE → RECORD → REVIEW',
  },
  {
    number: 5,
    title: '30 Reflexology Practice Checklists™',
    value: 17,
    image: 'https://cdn.magicpatterns.com/uploads/aGWjsm5t93AA3nQhhr9JD5/BONUS_5_REFLEXPRACTICE-EN.png',
    intro: 'A collection of practical checklists you can use throughout your reflexology study and practice.',
    listLabel: 'Covering',
    items: ['Preparation', 'Study', 'Practice', 'Review', 'Materials', 'Organization', 'Documentation', 'Progress', 'Follow-up'],
    closing: 'Print them. Save them on your phone. Keep them beside your practice materials.',
  },
];
